import { CalendarPickerView } from "@mui/x-date-pickers"
import React from "react"
import { customPalette } from "../../../../theme"
import { DateInput } from "./DateInput"

interface IProps {
  label: string
  value: Date | undefined
  views?: readonly CalendarPickerView[] | undefined
  hideButton?: boolean
  errorText?: string
  helperText?: string
  disablePast?: boolean

  handleChange(date: Date | undefined): void
}

export function FormDateInput({
  label,
  value,
  handleChange,
  views,
  hideButton,
  errorText,
  helperText,
  disablePast = true,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <DateInput
      value={value}
      label={label}
      handleChange={handleChange}
      views={views}
      hideButton={hideButton}
      backgroundColor={customPalette.lightWhite}
      borderRadius={4}
      hideBorder
      helperText={helperText}
      errorText={errorText}
      disablePast={disablePast}
    />
  )
}
